import {
  getAllowedInstallments,
  IBudgetPaymentMethod,
} from 'modules/checkout/domain/entities';

/**
 * Se a lista de preço por forma do carrinho deve exibir esta forma de pagamento.
 *
 * Forma que o Vectis devolveu como inelegível continua na lista, porque ele manda junto o
 * motivo e o cliente precisa lê-lo — foi o que ficou decidido para o item que não aceita
 * desconto.
 *
 * Forma sem nenhuma parcela permitida não fecha o orçamento, e para esse caso o Vectis não
 * manda motivo nenhum: é só a marca parcela a parcela, por onde chega o teto do contrato
 * recorrente. Então a linha sai, como o bloco de parcelamento já faz — em vez de a tela
 * inventar um texto, ou de anunciar um preço numa forma que o checkout vai recusar.
 */
export default function isPaymentMethodListableInCart(
  method: IBudgetPaymentMethod,
): boolean {
  if (method.eligibility?.eligible === false) {
    return true;
  }

  // Forma que veio sem parcela nenhuma não diz nada sobre o teto. Não há o que avaliar, e tirar
  // o preço dela da tela removeria informação que hoje aparece.
  if (method.installments.length === 0) {
    return true;
  }

  return getAllowedInstallments(method).length > 0;
}
